import React, { useState } from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { dataSideBar } from './constant';
import { Button, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ArchiveIcon from '@mui/icons-material/Archive';
import { IMessage } from '../store/messagerieSlice';
import { useSelector } from 'react-redux';
import { IReduxState } from '../store';
import EditIcon from '@mui/icons-material/Edit';
import PostDialog from '../SpiderWebSite/components/PostDialog';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../util/apiClient';
import { errorNotify, successNotify } from '../util/functions';
import { EditMessage } from './FocusEcole/Edit';
import PostEditDialog from '../SpiderWebSite/components/PostEditDialog';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';




interface Data {
    id: number;
    destinataire: string;
    title: number;
    message: number;
}


function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

type Order = 'asc' | 'desc';

function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
// function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
//     const stabilizedThis = array?.map((el, index) => [el, index] as [T, number]);
//     stabilizedThis.sort((a, b) => {
//         const order = comparator(a[0], b[0]);
//         if (order !== 0) {
//             return order;
//         }
//         return a[1] - b[1];
//     });
//     return stabilizedThis.map((el) => el[0]);
// }

interface HeadCell {
    disablePadding: boolean;
    id: any;
    label: string;
    numeric: boolean;
}

const headCells: readonly HeadCell[] = [
    {
        id: 'destinataire',
        numeric: false,
        disablePadding: true,
        label: 'Destinataire',
    },
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: 'Title',
    },
    {
        id: 'message',
        numeric: true,
        disablePadding: false,
        label: 'Message',
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'Action',
    }
];

interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler =
        (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, property);
        };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells?.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.id == "action" ? "right" : "left"}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

interface EnhancedTableToolbarProps {
    numSelected: number;
    indexSideBarSelected: number;
    handleSendMessage: any;
    loadingSendMessage: any;
    handleArchiveMessage: any;
    loadingArchiveMessage: any;
    handleDeleteMessage: any;
    loadingDeleteMessage: any;
    search: any;
    setSearch: any;
}



function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const { numSelected,
        indexSideBarSelected,
        handleSendMessage,
        loadingSendMessage,
        handleArchiveMessage,
        loadingArchiveMessage,
        handleDeleteMessage,
        loadingDeleteMessage,
        search,
        setSearch
    } = props;


    const dataActionButton = [
        {
            id: 1,
            label: "Renvoyer",
            icone: <SendIcon fontSize='small' />,
            handleSubmit: handleSendMessage,
            loading: loadingSendMessage
        },
        {
            id: 2,
            label: "Archiver",
            icone: <ArchiveIcon fontSize='small' />,
            handleSubmit: handleArchiveMessage,
            loading: loadingArchiveMessage
        },
        {
            id: 3,
            label: "Supprimer",
            icone: <DeleteIcon fontSize='small' />,
            handleSubmit: handleDeleteMessage,
            loading: loadingDeleteMessage
        },
    ]


    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    Sélection: ({numSelected})
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="body1"
                    id="tableTitle"
                    component="div"
                >
                    {indexSideBarSelected === 0 ? `Tous les messages ` : `Messages ${dataSideBar[indexSideBarSelected]?.label.toLowerCase()}`}
                </Typography>
            )}
            {numSelected > 0 ? (
                <div style={{ display: "flex" }}>
                    {dataActionButton.map((b => (
                        <Tooltip title={b.label}>
                            <IconButton
                                onClick={(e: any) => b.handleSubmit(e)}
                            >
                                {!b.loading
                                    ? b.icone
                                    : (<LoadingButton
                                        loadingPosition="end"
                                        loading={b.loading}
                                        size="small"
                                        variant="text"
                                        type="submit"
                                    >
                                    </LoadingButton>)
                                }
                            </IconButton>
                        </Tooltip>
                    )))}
                </div>
            ) : (
                <TextField
                    style={{ marginBottom: 5 }}
                    fullWidth
                    size="small"
                    name="search"
                    label="Recherche"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            )
            }
        </Toolbar >
    );
}
export default function ContentMessage(props: any) {
    const { indexSideBarSelected, filteredMessages, setFilteredMessages, handleSelectAllClick, handleClick } = props;
    const messages = useSelector((state: IReduxState) => state.messagerie).messages;

    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof Data>('message');
    const [selected, setSelected] = React.useState<readonly number[]>([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [editMessage, setEditMessage] = React.useState<any>()
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const [open, setOpen] = React.useState<boolean>(false)
    const [addLoading, setAddLoading] = useState<boolean>(false)

    //---------------------------------------------//
    const [search, setSearch] = React.useState('');

    const filterFunction = () => {
        if (search.length === 0) {
            setFilteredMessages([...messages]);
        } else {
            const result = filteredMessages.filter((item: any) => {
                const value = `${item.codeEtab} ${item.messageTitle} ${item.phone}`;
                return value.toLowerCase().includes(search.toLowerCase());
            });
            setFilteredMessages(result);
        }
    };

    React.useEffect(() => {
        filterFunction();
    }, [search, messages]);
    //--------------------------------------------//

    const onClose = () => {
        setOpen(false)
    }

    const handleOpenDialog = (e: any, row: any) => {
        e.preventDefault()
        setOpen(true)
        setEditMessage(row)
    }

    const handleEditMessage = async (e: any) => {
        try {
            e.preventDefault()
            setAddLoading(true)
            const apiPayload: any = {
                ...editMessage
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermessage", apiPayload);
            if (res.status === 1) {
                // dispatch(addMessage(res.data.message))
                successNotify("Action effectuée avec succès");
                setAddLoading(false)
            } else {
                errorNotify("Erreur");
                setAddLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleEditMessage ~ error:", error)
            setAddLoading(false)
        }
    }

    const [loadingSendMessage, setLoadingSendMessage] = useState(false)
    const handleSendMessage = async (e: any) => {
        try {
            e.preventDefault()
            setLoadingSendMessage(true)
            const apiPayload: any = {
                messages: selected
            }
            console.log("🚀 ~ handleEditMessage ~ apiPayload:", apiPayload)
            return
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermessage", apiPayload);
            if (res.status === 1) {
                // dispatch(addMessage(res.data.message))
                successNotify("Action effectuée avec succès");
                setAddLoading(false)
            } else {
                errorNotify("Erreur");
                setAddLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleEditMessage ~ error:", error)
            setAddLoading(false)
        }
    }

    const [loadingArchiveMessage, setLoadingArchiveMessage] = useState(false)
    const handleArchiveMessage = async (e: any) => {
        try {
            e.preventDefault()
            setLoadingArchiveMessage(true)
            const apiPayload: any = {
                messages: selected
            }
            console.log("🚀 ~ handleEditMessage ~ apiPayload:", apiPayload)
            return
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermessage", apiPayload);
            if (res.status === 1) {
                // dispatch(addMessage(res.data.message))
                successNotify("Action effectuée avec succès");
                setAddLoading(false)
            } else {
                errorNotify("Erreur");
                setAddLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleEditMessage ~ error:", error)
            setAddLoading(false)
        }
    }

    const [loadingDeleteMessage, setLoadingDeleteMessage] = useState(false)
    const handleDeleteMessage = async (e: any) => {
        try {
            e.preventDefault()
            setLoadingDeleteMessage(true)
            const apiPayload: any = {
                messages: selected
            }
            console.log("🚀 ~ handleEditMessage ~ apiPayload:", apiPayload)
            return
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermessage", apiPayload);
            if (res.status === 1) {
                // dispatch(addMessage(res.data.message))
                successNotify("Action effectuée avec succès");
                setAddLoading(false)
            } else {
                errorNotify("Erreur");
                setAddLoading(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleEditMessage ~ error:", error)
            setAddLoading(false)
        }
    }

    // Filtrer la liste des établissements en fonction du terme de recherche saisi
    // const filterData = () => {
    //     if (!searchTerm.length) {
    //         setLocalMessage(messages)
    //     } else {
    //         const data = messages?.filter((item: IMessage) => {
    //             const values = `${item.codeEtab} ${item.anneeScolaire} ${item.messageTitle} ${item.messageContent}`
    //             return values.toString().toLowerCase().includes(searchTerm.toLowerCase())
    //         });
    //         setLocalMessage(data)
    //     }
    // }

    // React.useEffect(() => {
    //     filterData()
    // }, [searchTerm])



    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: keyof Data,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (event.target.checked) {
    //         const newSelected: any = dataSideBar[indexSideBarSelected]?.status === undefined
    //             ? messages.map((n) => n.messageId)
    //             : messages.filter(elt => elt.messageArcived === dataSideBar[indexSideBarSelected]?.status).map((n) => n.messageId);
    //         setSelected(newSelected);
    //         return;
    //     }
    //     setSelected([]);
    // };

    // const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    //     const selectedIndex = selected.indexOf(id);
    //     let newSelected: readonly number[] = [];
    //     if (selectedIndex === -1) {
    //         newSelected = newSelected.concat(selected, id);
    //     } else if (selectedIndex === 0) {
    //         newSelected = newSelected.concat(selected.slice(1));
    //     } else if (selectedIndex === selected.length - 1) {
    //         newSelected = newSelected.concat(selected.slice(0, -1));
    //     } else if (selectedIndex > 0) {
    //         newSelected = newSelected.concat(
    //             selected.slice(0, selectedIndex),
    //             selected.slice(selectedIndex + 1),
    //         );
    //     }
    //     setSelected(newSelected);
    // };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDense(event.target.checked);
    };

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty messages.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - messages.length) : 0;

    // const visibleRows = React.useMemo(
    //     () =>
    //         stableSort(messages, getComparator(order, orderBy)).slice(
    //             page * rowsPerPage,
    //             page * rowsPerPage + rowsPerPage,
    //         ),
    //     [order, orderBy, page, rowsPerPage],
    // );

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2, backgroundColor: "#fcfafc" }}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    indexSideBarSelected={indexSideBarSelected}
                    handleSendMessage={handleSendMessage}
                    loadingSendMessage={loadingSendMessage}
                    handleArchiveMessage={handleArchiveMessage}
                    loadingArchiveMessage={loadingArchiveMessage}
                    handleDeleteMessage={handleDeleteMessage}
                    loadingDeleteMessage={loadingDeleteMessage}
                    search={search}
                    setSearch={setSearch}
                />
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={"small"}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={messages.length}
                        />
                        <TableBody>
                            {
                                (() => {
                                    return filteredMessages?.map((row: any, index: number) => {
                                        const isItemSelected = isSelected(row.messageId);
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <TableRow
                                                hover
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.messageId}
                                                selected={isItemSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        role="checkbox"
                                                        color="primary"
                                                        checked={isItemSelected}
                                                        inputProps={{
                                                            'aria-labelledby': labelId,
                                                        }}
                                                        onClick={(event) => handleClick(event, row.messageId)}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                    style={{ color: "GrayText" }}
                                                >
                                                    {row.phone}
                                                </TableCell>
                                                <TableCell align="left" style={{ color: "GrayText" }}>{row.messageTitle}</TableCell>
                                                <TableCell align="left" style={{ fontSize: 12, color: "GrayText", textJustify: "initial" }}>{row.messageContent}</TableCell>
                                                <TableCell align="left" style={{ fontSize: 12, textJustify: "initial", color: `${row?.sentAt ? 'green' : 'red'}` }}>
                                                    {row?.sentAt ? <DoneIcon /> : <CloseIcon />}
                                                </TableCell>
                                                <TableCell align="right" style={{ fontSize: 12, color: "GrayText", textJustify: "initial" }}>
                                                    <IconButton
                                                        onClick={(e: any) => handleOpenDialog(e, row)}
                                                    >
                                                        <EditIcon fontSize='small' />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>

                                        );
                                    });
                                })()
                            }
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={messages.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <PostEditDialog
                onClose={onClose}
                open={open}
                dialogContent={
                    <EditMessage
                        editMessage={editMessage}
                        setEditMessage={setEditMessage}

                    />}
                actionFunc={handleEditMessage}
                title="Modification du message"
                editLoading={addLoading}
            />
        </Box>
    );
}
